import ws from '@api/webservice'
import config from '@app/config'

const api = {
  // list of active jobs
  all: () => ws<QuartzGroup>(config.ws.quartz.all, 'GET'),
  // get infos for jobs
  info: (name: string) => ws<QuartzInfo>(`${config.ws.quartz.all}/${name}`, 'GET'),
  // start jobs
  start: (name: string) => ws<QuartzInfo>(`${config.ws.quartz.all}/${name}`, 'POST', {}),
}

export default api
